import useSignaturePositioning from "@/utils/hooks/useSignaturePositioning";
import PageLayout from "@components/core/layouts/PageLayout";
import Positioning from "@components/core/subComponents/Positioning";
import { ROUTES } from "@routes/Routes";
import { FunctionComponent } from "react";

const ModelSignaturePositioningScreen: FunctionComponent = () => {
  const {
    transactionType,
    files,
    signatories,
    signatures,
    signatureRequirementMode,
    setSignatureRequirementMode,
    manualPositioning,
    setManualPositioning,
    officeId,
  } = useSignaturePositioning();

  return (
    <PageLayout container returnRoute={ROUTES.extranet.home.generate()}>
      <Positioning
        transactionType={transactionType}
        files={files}
        signatories={signatories}
        signatures={signatures}
        signatureRequirementMode={signatureRequirementMode}
        setSignatureRequirementMode={setSignatureRequirementMode}
        manualPositioning={manualPositioning}
        setManualPositioning={setManualPositioning}
        isFromModelTransaction
        officeId={officeId ?? ""}
        members={[]}
      />
    </PageLayout>
  );
};

export default ModelSignaturePositioningScreen;
